import script from "./BaseProcessComponentV2.vue?vue&type=script&lang=ts"
export * from "./BaseProcessComponentV2.vue?vue&type=script&lang=ts"

import "./BaseProcessComponentV2.vue?vue&type=style&index=0&id=76ffa346&lang=scss"

const __exports__ = script;

export default __exports__